import { defineMessages } from 'react-intl';
export default defineMessages({
    alerts: {
        id: 'landing.alerts',
        defaultMessage: 'Alerts',
    },
    alertsDescription: {
        id: 'landing.alertsDescription',
        defaultMessage: 'Create your own alerts and get notified as soon as they are triggered.',
    },
    featureAlertsDescription: {
        id: 'landing.featureAlertsDescription',
        defaultMessage: 'Set custom thresholds for any metric. Get notified when temperature drops, rain starts, or wind picks up.',
    },
    featureAlertsTitle: {
        id: 'landing.featureAlertsTitle',
        defaultMessage: 'Smart Alerts',
    },
    featureAnalyticsDescription: {
        id: 'landing.featureAnalyticsDescription',
        defaultMessage: 'Interactive charts, trend analysis, and detailed statistics. Dive deep into temperature, humidity, pressure, rain, and wind data.',
    },
    featureAnalyticsTitle: {
        id: 'landing.featureAnalyticsTitle',
        defaultMessage: 'Advanced Analytics',
    },
    featureExportDescription: {
        id: 'landing.featureExportDescription',
        defaultMessage: 'Download your weather data as CSV files for further analysis in Excel, Google Sheets, or your favorite tools.',
    },
    featureExportTitle: {
        id: 'landing.featureExportTitle',
        defaultMessage: 'Export Your Data',
    },
    featureForecastDescription: {
        id: 'landing.featureForecastDescription',
        defaultMessage: 'Access 10+ professional forecast models including ECMWF, GFS, and regional models. Compare them side-by-side to make your own predictions.',
    },
    featureForecastTitle: {
        id: 'landing.featureForecastTitle',
        defaultMessage: 'Compare Forecast Models',
    },
    featureHistoryDescription: {
        id: 'landing.featureHistoryDescription',
        defaultMessage: 'Access historical data with hourly, daily, and monthly scales. Export to CSV for research or personal archives.',
    },
    featureHistoryTitle: {
        id: 'landing.featureHistoryTitle',
        defaultMessage: 'Rich History',
    },
    featureMultiBrandDescription: {
        id: 'landing.featureMultiBrandDescription',
        defaultMessage: 'Connect Netatmo, Davis, Tempest, Ecowitt, Ambient Weather, and more. No more switching between apps.',
    },
    featureMultiBrandTitle: {
        id: 'landing.featureMultiBrandTitle',
        defaultMessage: 'All Brands, One App',
    },
    featuresSubtitle: {
        id: 'landing.featuresSubtitle',
        defaultMessage: 'SmartMixin gives you the tools to analyze, compare, and understand your weather data like a pro.',
    },
    featuresTitle: {
        id: 'landing.featuresTitle',
        defaultMessage: 'Built for data lovers',
    },
    finalCtaButton: {
        id: 'landing.finalCtaButton',
        defaultMessage: 'Create Free Account',
    },
    finalCtaSubtitle: {
        id: 'landing.finalCtaSubtitle',
        defaultMessage: 'Join thousands of weather enthusiasts who trust SmartMixin.',
    },
    finalCtaTitle: {
        id: 'landing.finalCtaTitle',
        defaultMessage: 'Ready to dive deeper into your weather data?',
    },
    forecastDescription: {
        id: 'landing.forecastDescription',
        defaultMessage: 'Access some of the best weather forecast models and compare them to get your own idea of what the weather will be.',
    },
    forecasts: {
        id: 'landing.forecasts',
        defaultMessage: 'Forecasts',
    },
    heroCta: {
        id: 'landing.heroCta',
        defaultMessage: 'Start Free',
    },
    heroDescription: {
        id: 'landing.heroDescription',
        defaultMessage: 'Deep analytics, beautiful charts, and professional forecasts — all your weather stations unified in one powerful app.',
    },
    heroSecondaryCta: {
        id: 'landing.heroSecondaryCta',
        defaultMessage: 'Explore the Map',
    },
    heroTagline: {
        id: 'landing.heroTagline',
        defaultMessage: 'For Weather Enthusiasts',
    },
    heroTitle: {
        id: 'landing.heroTitle',
        defaultMessage: 'See your weather like never before',
    },
    pricingFeatureAdvancedMetrics: {
        id: 'landing.pricingFeatureAdvancedMetrics',
        defaultMessage: 'Advanced metrics',
    },
    pricingFeatureAlerts: {
        id: 'landing.pricingFeatureAlerts',
        defaultMessage: 'Custom alerts',
    },
    pricingFeatureExport: {
        id: 'landing.pricingFeatureExport',
        defaultMessage: 'Data export (CSV)',
    },
    pricingFeatureForecastComparison: {
        id: 'landing.pricingFeatureForecastComparison',
        defaultMessage: 'Forecast comparison',
    },
    pricingFeatureForecasts: {
        id: 'landing.pricingFeatureForecasts',
        defaultMessage: 'Forecast models',
    },
    pricingFeatureForecastsFreeTier: {
        id: 'landing.pricingFeatureForecastsFreeTier',
        defaultMessage: '1 model',
    },
    pricingFeatureForecastsPremiumTier: {
        id: 'landing.pricingFeatureForecastsPremiumTier',
        defaultMessage: '10+ models',
    },
    pricingFeatureReports: {
        id: 'landing.pricingFeatureReports',
        defaultMessage: 'Analysis & reports',
    },
    pricingFeatureStationComparison: {
        id: 'landing.pricingFeatureStationComparison',
        defaultMessage: 'Station comparison',
    },
    pricingFeatureWidgets: {
        id: 'landing.pricingFeatureWidgets',
        defaultMessage: 'Home screen widgets',
    },
    pricingFeatureYearOverYear: {
        id: 'landing.pricingFeatureYearOverYear',
        defaultMessage: 'Year-over-year analysis',
    },
    pricingFree: {
        id: 'landing.pricingFree',
        defaultMessage: 'Free',
    },
    pricingFreeCta: {
        id: 'landing.pricingFreeCta',
        defaultMessage: 'Get Started',
    },
    pricingFreePrice: {
        id: 'landing.pricingFreePrice',
        defaultMessage: '0 €',
    },
    pricingMostPopular: {
        id: 'landing.pricingMostPopular',
        defaultMessage: 'Most Popular',
    },
    pricingPremium: {
        id: 'landing.pricingPremium',
        defaultMessage: 'Premium',
    },
    pricingPremiumCta: {
        id: 'landing.pricingPremiumCta',
        defaultMessage: 'Get Started',
    },
    pricingPremiumDescription: {
        id: 'landing.pricingPremiumDescription',
        defaultMessage: 'From 1.99 €/month — subscribe on web, App Store, or Google Play',
    },
    pricingSubtitle: {
        id: 'landing.pricingSubtitle',
        defaultMessage: 'Start free, upgrade when you need more power.',
    },
    pricingTitle: {
        id: 'landing.pricingTitle',
        defaultMessage: 'Simple, transparent pricing',
    },
    smartMixinDescription: {
        id: 'landing.smartMixinDescription',
        defaultMessage: 'SmartMixin is an application that provides access to your weather station and 40K+ other stations worldwide. It helps you see and understand weather data.',
    },
    statBrands: {
        id: 'landing.statBrands',
        defaultMessage: 'Brands supported',
    },
    statForecasts: {
        id: 'landing.statForecasts',
        defaultMessage: 'Forecast models',
    },
    statStations: {
        id: 'landing.statStations',
        defaultMessage: 'Weather stations',
    },
    supportedDevices: {
        id: 'landing.supportedDevices',
        defaultMessage: 'Supported devices',
    },
    supportedDevicesDescription: {
        id: 'landing.supportedDevicesDescription',
        defaultMessage: 'On top of the stations from the World Meteorological Organization, SmartMixin supports a growing number of weather stations brands.',
    },
    supportedDevicesNote: {
        id: 'landing.supportedDevicesNote',
        defaultMessage: 'Plus 40,000+ public stations from the World Meteorological Organization',
    },
    supportedDevicesSubtitle: {
        id: 'landing.supportedDevicesSubtitle',
        defaultMessage: 'Connect your existing weather station in minutes. We support 8 major brands and growing.',
    },
    supportedDevicesTitle: {
        id: 'landing.supportedDevicesTitle',
        defaultMessage: 'Works with your station',
    },
    thermostatDescription: {
        id: 'landing.thermostatDescription',
        defaultMessage: 'Connect your Netatmo thermostat to correlate heating patterns with outdoor conditions.',
    },
    thermostatManufacturers: {
        id: 'landing.thermostatManufacturers',
        defaultMessage: 'Thermostat manufacturers are also supported to correlate heating with outdoor conditions.',
    },
    thermostatTitle: {
        id: 'landing.thermostatTitle',
        defaultMessage: 'Smart home integration',
    },
    weatherAnalysis: {
        id: 'landing.weatherAnalysis',
        defaultMessage: 'Weather Analysis',
    },
    weatherAnalysisDescription: {
        id: 'landing.weatherAnalysisDescription',
        defaultMessage: 'SmartMixin comes with lots of data vizualization that lets you analyse weather data.',
    },
    weatherAssistant: {
        id: 'landing.weatherAssistant',
        defaultMessage: 'Your weather assistant',
    },
    weatherAssistantDescription: {
        id: 'landing.weatherAssistantDescription',
        defaultMessage: 'Whether you are interested in current, historical or forecast weather conditions, SmartMixin provides with numerous insights whenever you need them.',
    },
    weatherForecastModels: {
        id: 'landing.weatherForecastModels',
        defaultMessage: 'Weather forecast models',
    },
    weatherForecastModelsDescription: {
        id: 'landing.weatherForecastModelsDescription',
        defaultMessage: 'SmartMixin provides access to the most accurate weather forecast models. You can easily compare their forecasts and make your own idea.',
    },
    weatherMap: {
        id: 'landing.weatherMap',
        defaultMessage: 'Weather Map',
    },
    weatherMapDescription: {
        id: 'landing.weatherMapDescription',
        defaultMessage: "Browse the map and vizualize what's the weather like anywhere around the globe.",
    },
});
